import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesReset, EGetAuthorArticlesActionType } from './types';

export const getAuthorArticlesReset: () => TGetAuthorArticlesReset =
  actionGenerator<EGetAuthorArticlesActionType.Reset>(EGetAuthorArticlesActionType.Reset);
